import React from 'react';
import SurveyTab from './SurveyTab';

const FeedbackTab = () => {
  return (
    <SurveyTab 
      module="feedback"
      title="Annual Feedback"
      description="We value your thoughts, let us know how we can improve our processes and your experience"
    />
  );
};

export default FeedbackTab; 